// Define enums for user PermissionLevel
export enum PermissionLevel {
  READ = 'Read',
  WRITE = 'Write',
  EDIT = 'Edit',
  MODIFY = 'Modify', // TODO: remove?
  DELETE = 'Delete',
  APPROVE = 'Approve',
  LOG_ON_BEHALF = 'LogOnBehalf',
  BLOCK = 'Block',
  REPLACE = 'Replace',
  PIN_REPRINT = 'PinReprint',
  ACTIVATE = 'Activate',
  ASSIGN = 'Assign',
}
